import React, { useContext } from "react";
import { Route, RouteProps } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";

import { StandaloneContext } from "lib/context/StandaloneContext";
import NotFound from "components/common/NotFound";

interface BaseRouteProps extends RouteProps {
  useErrorBoundary?: boolean;
}

const BaseRoute: React.FC<BaseRouteProps> = ({
  component,
  useErrorBoundary = false,
  ...rest
}) => {
  const { authRoute: AuthRoute } = useContext(StandaloneContext);
  const RouteType = AuthRoute || Route;
  const Component = component as React.ComponentType;
  return useErrorBoundary ? (
    <RouteType
      {...rest}
      component={() => {
        return (
          <ErrorBoundary fallback={<NotFound />}>
            <Component />
          </ErrorBoundary>
        );
      }}
    />
  ) : (
    <RouteType {...rest} component={component} />
  );
};

export default BaseRoute;
